import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import EzControlledDropDowntWithFloatingLabel from "../../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import "./styles.css";
import Breadcrumb from "../../../../common/Breadcrumb";
import { useStyles } from "../style";
import {
  rateTypeFromDD,
  basicDetail,
  basicDetailTo,
  editMode,
  statusDD,
} from "../CreateRateAdminRateMirrors/constant";
import { Box, Container, Grid } from "@mui/material";
import EzControlledInputWithFloatingLabel from "../../../../common/EzForm/EzControlledInput/WithFloatingLabel";
import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import { useNavigate } from "react-router-dom";
import { APP_URLS } from "../../../../utils/constant";
import { RateAdminBreadcrumb } from "../../RateAdminRateCode/CreateRateAdminRateCode/constant";
import { getFormBaseValidationRule } from "../../../../utils/form/form-utils";

const CreateRateAdminRateMirrorsComponent = (props) => {
  const navigate = useNavigate();
  const {
    history,
    initCreateRateAdminRateMirrorsScreen,
    createRateAdminRateMirrors,
    editRateAdminRateMirrors,
    isLoading,
    isRateAdminRateMirrorsCreateSuccess,
    isRateAdminRateMirrorsCreateError,
    isRateAdminRateMirrorsDetailSuccess,
    isRateAdminRateMirrorsDetailError,
    isRateAdminRateMirrorsEditSuccess,
    isEdit,
    isCopy,
    isView,
    formFieldValueMap,
    shouldBlockNavigation,
    uploadImage,
    imageUploadResponse,
    isUploadImageSuccess,
    isUploadImageError,
    vehicleModelDD,
    isVehicleModelDDSuccess,
    isVehicleModelDDError,
    locationDD,
    vehicleCategoryDD,
    RateCodeDD,
    RateNetworkDD,
    categoryDD,
  } = props;
  console.log("check props of compoemnt", props);

  const classes = useStyles();

  const {
    control,
    formState: { errors, isDirty },
    watch,
    register,
    resetField,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: useMemo(() => {
      console.log("check value come or not", formFieldValueMap);
      return formFieldValueMap;
    }, [formFieldValueMap]),
  });

  useEffect(() => {
    if (!isRateAdminRateMirrorsCreateSuccess && !isRateAdminRateMirrorsEditSuccess) {
      shouldBlockNavigation(isDirty);
    }
  }, [isDirty, shouldBlockNavigation, isRateAdminRateMirrorsCreateSuccess, isRateAdminRateMirrorsEditSuccess]);

  const navigateToRateAdminRateMirrorsScreen = () => {
    navigate(APP_URLS.RATEADMIN_RATEMIRRORS.HOME);
  };
  useEffect(() => {
    if (
      isRateAdminRateMirrorsCreateSuccess ||
      isRateAdminRateMirrorsEditSuccess
    ) {
      reset();
    }
  }, [isRateAdminRateMirrorsCreateSuccess, isRateAdminRateMirrorsEditSuccess]);
  useEffect(() => {
    initCreateRateAdminRateMirrorsScreen();
  }, []);

  useEffect(() => {
    if (isRateAdminRateMirrorsDetailSuccess) {
      reset({
        ...formFieldValueMap,
      });
      setPickupAllowed(formFieldValueMap?.pickupAllowed === 1 ? true : false);
      setSpanoverAllowed(
        formFieldValueMap?.spanoverAllowed === 1 ? true : false
      );
    }
  }, [isRateAdminRateMirrorsDetailSuccess, formFieldValueMap]);
  const [pickupAllowed, setPickupAllowed] = useState(false);
  const [spanoverAllowed, setSpanoverAllowed] = useState(false);

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    if (name == "pickupAllowed") {
      setPickupAllowed(checked);
    }
    if (name == "spanoverAllowed") {
      setSpanoverAllowed(checked);
    }
  };
  const onSubmit = (data) => {
    let newData = { ...data };
    newData["userId"] = localStorage.getItem("userId");
    newData["pickupAllowed"] = pickupAllowed === true ? 1 : 0;
    newData["spanoverAllowed"] = spanoverAllowed === true ? 1 : 0;
    newData["status"] = 1;
    
    if (isCopy) {
      // For copy, remove id to create a new record
      delete newData.id;
      createRateAdminRateMirrors(newData);
    } else if (isEdit) {
      editRateAdminRateMirrors({ id: data.id, data: newData });
    } else {
      createRateAdminRateMirrors(newData);
    }
  };
  const getToastProps = () => {
    const toastTitle = "Please select category from list";
    return {
      severity: TOAST_SEVERITY.ERROR,
      toastTitle,
      shouldShowToast: false,
    };
  };

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const renderPageHeaderSection = () => {
    const getPageTitle = () => {
      if (isCopy) return "Create Rate Mirror";
      if (isEdit) return "Update Rate Mirror";
      return "Create Rate Mirror";
    };
    
    return (
      <div className="make-relative sub-header ">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">{getPageTitle()}</h4>
          </div>
          <div className="buttonarea">
            <Button
              tooltip={"Back to Rate Mirrors"}
              tooltipOptions={{ position: "left" }}
              label={"Back to Rate Mirrors"}
              // icon={"pi pi-arrow-left"}
              className={`p-button `}
              style={{ borderRadius: "10px" }}
              onClick={navigateToRateAdminRateMirrorsScreen}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Container maxWidth="lg">
      <Breadcrumb list={RateAdminBreadcrumb} />
      <EzToast {...getToastProps()} />
      <div className={`containerbox ${classes.bg}`}>
        {renderPageHeaderSection()}
        <div className="form-demo">
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <h4 className="pagetitlemirror">Mirror From</h4>
            <Grid container spacing={2}>
              {basicDetail?.map((item) =>
                item.name === "fkRateTypeIdFrom" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={rateTypeFromDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "fkLocationFrom" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={locationDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "fkVehicleClassFrom" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={categoryDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "fkRateGroupFrom" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={RateCodeDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "fkNetworkFrom" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={RateNetworkDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledInputWithFloatingLabel
                      name={item?.name}
                      control={control}
                      label={item?.label}
                      type={item?.type}
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                    />
                  </Grid>
                ),
              )}
            </Grid>
            <h4 className="pagetitlemirror">Mirror To</h4>
            <Grid container spacing={2}>
              {basicDetailTo?.map((item) =>
                item.name === "fkRateTypeIdTo" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={rateTypeFromDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "fkLocationTo" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={locationDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "fkVehicleClassTo" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={categoryDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "fkRateGroupTo" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={RateCodeDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : item.name === "fkNetworkTo" ? (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledDropDowntWithFloatingLabel
                      name={item?.name}
                      control={control}
                      rules={item?.rule}
                      optionLabel={"name"}
                      optionValue={"id"}
                      options={RateNetworkDD}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                      label={item?.label}
                      labelClassName={"ml-2"}
                    />
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledInputWithFloatingLabel
                      name={item?.name}
                      control={control}
                      label={item?.label}
                      type={item?.type}
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                    />
                  </Grid>
                ),
              )}
            </Grid>
            <div className={"make-flex mt-3 mr-2"}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "end",
                }}
              >
                <React.Fragment>
                  <div
                    style={{ margin: "15px 0px 15px 10px", minWidth: "100px" }}
                  >
                    <Button
                      type="submit"
                      label={isEdit ? "Update" : "Save"}
                      className="mt-2 p-button-raised"
                    />
                  </div>
                </React.Fragment>
              </div>
            </div>
            {isEdit && (
              <Grid className="modsection" container spacing={2}>
                {editMode?.map((item) => (
                  <Grid item xs={3} key={item.name}>
                    <EzControlledInputWithFloatingLabel
                      name={item?.name}
                      control={control}
                      disabled={item?.disabled}
                      label={item?.label}
                      type={item?.type}
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
          </form>
        </div>
      </div>
    </Container>
  );
};

export default CreateRateAdminRateMirrorsComponent;
